import React, {useEffect} from "react";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "../../../components/Grid/GridItem.js";
import GridContainer from "../../../components/Grid/GridContainer.js";
import Card from "../../../components/Card/Card.js";
import CardHeader from "../../../components/Card/CardHeader.js";
import CardBody from "../../../components/Card/CardBody.js";
import QueueAnim from "rc-queue-anim";
import Alert from "react-s-alert";
import {primaryColor, secondaryColor} from "../../../assets/jss/material-dashboard-react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, FormControl, InputLabel, Select,
    TextField
} from "@material-ui/core";
import DataGrid, {
    Column, Export, FilterRow,
    GroupPanel, HeaderFilter,
    Pager, Paging, Editing,
    SearchPanel, Sorting
} from "devextreme-react/data-grid";
import {addCategory, getAllCategory, removeCategory, updateCategory} from "../../../util/Contexts/CategoryContext";
import {handleError} from "../../../util/Contexts/ErrorContext";
import {getAllDepartmets, getAllDepartmentsEnabled} from "../../../util/Contexts/DepartmentContext";
import esMessages from 'devextreme/localization/messages/es.json';
import { locale, loadMessages } from 'devextreme/localization';
import Typography from "@material-ui/core/Typography";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color:  primaryColor[0],
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color:  primaryColor[0]
        }
    },
    cardTitleWhite: {
        color: primaryColor[0],
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    }
};

const useStyles = makeStyles(styles);


export default function CategoryList() {

    const classes = useStyles();
    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [openConfirmation, setOpenConfirmation] = React.useState(false);
    const [lookup, setLookup] = React.useState({});
    const [state, setState] = React.useState({
        stateSelected: 0,
        filter: "",
        name: "",
        id: 0,
        description: "",
        edit: false,
        officeAsigned: 1
    });
    const [offices, setOffices] = React.useState([]);

    loadMessages(esMessages);
    locale("es");

    function handleClickOpen(row) {
      var item = null;
      if(row.row != null){
        for(let i = 0; i < data.length; i++){
          if(row.row.key === data[i].id){
            item = data[i]
          }
        }
      }
      console.log(item)
      item ? setState({
        ...state,
        name: item.name,
        id: item.id,
        description: item.description,
        officeAsigned: item.department.id,
        edit: true
      }) :  setState({
        ...state,
        name: "",
        description: "",
        officeAsigned: 1,
        edit: false
      });
      setOpen(true);
    }

    function handleClose() {
        setOpen(false);
        setOpenConfirmation(false);
    }

    const handleChange = event => {
        setState( {
            ...state,
            [event.target.name] : event.target.value
        });
    };

    function enable(rowData) {
      rowData.row.data.enabled = !rowData.row.data.enabled

        var item = null;
        for(let i = 0; i < offices.length; i++){
            if(state.officeAsigned === offices[i].id){
                console.log("Adentro de If")
                item = offices[i]
            }
        }

        let newData = {
            name: rowData.row.data.name,
            description: rowData.row.data.description,
            enabled: rowData.row.data.enabled,
            department: item
        }

      updateCategory(rowData.row.data.id, newData).then(respuesta => {
        Alert.success(respuesta.data.message);
        handleClose();
        getAllData();
    } )
    }

    function handleDelete(row) {
        setOpenConfirmation(true);
        setState({...state, id: row.row.data.id})
    }

    function deleteObject () {
        removeCategory(state.id).then(respuesta => {
            Alert.success(respuesta.data.message);
            handleClose();
            getAllData();
        } )
    }


    function getDepartments() {
        getAllDepartmentsEnabled().then(respuesta => {
            setOffices(respuesta.data.data);
        })

    }

    const renderStatus = (cellInfo) => {
      if(cellInfo.data.enabled){
        return(
          <div align={"center"}>
            Verdadero
          </div>
          );
      } else {
        return(
          <div align={"center"}>
            Falso
          </div>
          );
      }
    }

    const updateData =  (event)  => {
      event.preventDefault();
      var item = null;
      for(let i = 0; i < offices.length; i++){
        if(state.officeAsigned == offices[i].id){
          console.log("Adentro de If")
          item = offices[i]
        }
      }
      let newData = {
        name: state.name,
        description: state.description,
        enabled: true,
        department: item
      }
        updateCategory(state.id,newData).then(respuesta => {
            Alert.success(respuesta.data.message);
            handleClose();
            getAllData();
        } )
    };

    const getAllData = () => {
        setLoading(true);
        getAllCategory().then(respuesta => {
            setLoading(false);
            setData(respuesta.data.data);
        } )
    };

    useEffect(value => {
        getAllData();
        getDepartments();
    }, []);

    const addData = (event) => {
        setLoading(true);
        event.preventDefault();
        addCategory(state).then(respuesta => {
            Alert.success(respuesta.data.message);
            setState({
                ...state,
                name: "",
                description: ""
            });
            handleClose();
            getAllData();
            setLoading(false);
        } )
    };

    function onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'plus',
          onClick: handleClickOpen.bind()
        }
      });
    }

    return (
        <div>

                <GridContainer>
                  <Dialog open={open} onClose={handleClose}>
                    <DialogTitle id="form-dialog-title">{state.edit ? "Editar categoría" : "Agregar categoría"}</DialogTitle>
                    <form onSubmit={state.edit ? updateData : addData}>
                      <DialogContent>
                        <TextField
                          required={true}
                          margin="dense"
                          id="name"
                          name="name"
                          value={state.name}
                          onChange={handleChange}
                          label="Nombre"
                          type="text"
                          fullWidth
                        />
                        <TextField
                          margin="dense"
                          id="description"
                          name="description"
                          value={state.description}
                          onChange={handleChange}
                          label="Descripción"
                          type="text"
                          fullWidth
                        />
                        <FormControl fullWidth required>
                          <InputLabel htmlFor="officeAsigned">Departamentos</InputLabel>
                          <Select
                            required
                            native
                            value={state.officeAsigned}
                            onChange={handleChange}
                            inputProps={{
                              name: 'officeAsigned',
                              id: 'officeAsigned',
                            }}
                          >
                            <option value="" />
                              {offices.map(function(value) { return (<option key={value.name} value={value.id} > {value.name}</option> );})}
                          </Select>
                        </FormControl>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={handleClose} color="primary">
                          Cancelar
                        </Button>
                        <Button type={"submit"}  color="primary">
                          Guardar
                        </Button>
                      </DialogActions>
                    </form>
                  </Dialog>
                  <Dialog open={openConfirmation} onClose={handleClose}>
                      <DialogTitle id="form-dialog-title">Confirmación</DialogTitle>
                      <DialogContent>
                          <Typography> ¿Esta seguro que desea eliminar la categoría? </Typography>
                      </DialogContent>
                      <DialogActions>
                          <Button onClick={handleClose} color="primary">
                              Cancelar
                          </Button>
                          <Button color="primary" onClick={deleteObject}>
                              Aceptar
                          </Button>
                      </DialogActions>
                  </Dialog>

                  <GridItem xs={12} sm={12} md={12}>
                    <Card>
                      <CardHeader color="secondary">
                        <h4 className={classes.cardTitleWhite}>Listado de categorias</h4>
                        <p className={classes.cardCategoryWhite}>

                        </p>
                      </CardHeader>
                      <CardBody>
                        <QueueAnim>
                          <DataGrid
                            dataSource={data}
                            showBorders={true}
                            keyExpr="id"
                            allowColumnReordering={true}
                            allowColumnResizing={true}
                            onToolbarPreparing={onToolbarPreparing}>

                            {/* <Export enabled={true} fileName={"Tickets"} texts={{exportAll: "Exportar todos lo datos"}}/>   */}
                            
                            <FilterRow visible={true} applyFilter={"auto"} />
                            
                            <HeaderFilter visible={true} />
                            
                            {/*<GroupPanel visible={true} emptyPanelText={"Arrastre una columna para agrupar"} />*/}
                            
                            <SearchPanel visible={true}
                              width={240}
                              placeholder="Buscar..." />
                            
                            <Paging defaultPageSize={10} />
                            
                            <Pager
                              showPageSizeSelector={true}
                              allowedPageSizes={[5, 10, 20]}
                              showInfo={true} />
                              
                            <Sorting mode="multiple" />

                            <Column
                              dataField="name"
                              caption="Nombre"/>

                            <Column
                              dataField="description"
                              caption="Descripción"/>

                            <Column
                              dataField="department.name"
                              caption="Departemento"/>

                            <Column
                                dataField="statusEnum.description"
                              caption="Estatus"/>

                            <Column type="buttons"
                              visible={state.displayRole}
                              caption="Acciones"
                              width={80}
                              buttons={[{
                                  hint: 'Deshabilitar',
                                  icon: 'remove',
                                  visible: (e) => (e.row.data.enabled),
                                  onClick: enable
                              },
                                  {
                                      hint: 'Habilitar',
                                      icon: 'check',
                                      visible: (e) => (!e.row.data.enabled),
                                      onClick: enable
                                  }, {
                                hint: 'Editar',
                                icon: 'edit',
                                onClick: handleClickOpen
                            }, {
                                  hint: 'Eliminar',
                                  icon: 'trash',
                                  onClick: handleDelete
                              }]}/>
                          </DataGrid>
                        </QueueAnim>
                      </CardBody>
                    </Card>
                  </GridItem>
                </GridContainer>


        </div>


    );
}